export const config = {
  MD_BREAKPOINT: "(max-width: 768px)",
  PATH_URI: {
    HOME: "/",
    PROPERTY_CREATE: "/create",
    PROPERTY_DETAILS: "/detail",
    IMAGE_SEARCH: "/image-search",
    USER_MANAGEMENT: "/user-management",
    LOGIN: "/login",
    PROPERTY_UPDATE: "/property/update/:id",
    PRODUCT_CATALOG: "/product-catalog",
    PROPERTY_SHEET: {
      MAIN: "/property-sheet",
      get DETAIL() {
        return `${this.MAIN}/detail`;
      },
    },
    PROPERTY_LANDING_PAGE: "/property-landing-page/:id",
    PROPERTY_ROOM_DETAILS: "/property-landing-page/room/:id",
    CHECKOUT_CONFIRMATION: "/checkout/success",
    INVOICE: "/invoice"
  },
  ERROR: "Internal Server Error",
  SERVER: (() => {
    // Use BASE_URL from config for Node API endpoints
    const { environmentConfig } = require('../config/config.js');
    return process.env.REACT_APP_BASE_URL || environmentConfig.BASE_URL || 'https://';
  })(),
  ROOM_TYPES: [
    "New Build Single-Family Home",
    "Existing Single-Family Home",
    "New Build Multi-Unit Property",
    "Existing Multi-Unit Property",
  ],
  INCLUDED_ROOMS: [
    "Great room",
    "Living room",
    "Kitchen",
    "Dining room",
    "Family room",
    "Primary bedroom",
    "Outdoor patio/terrace",
    "Additional bedrooms",
    "Office/Den",
    "Media/Game Room",
    "Foyer/Hallway",
    "Full Bathroom",
    "Half Bathroom"
  ],
  projectStatusOptions: ["Pending Client Acceptance","Invoice Paid","Revisions","Installation"],
  AUTH_STEPS: {
    SIGN_UP: "SIGN_UP",
    CONFIRM_SIGN_UP: "CONFIRM_SIGN_UP",
    SIGN_IN: "SIGN_IN",
    CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED: "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED",
    RESET_PASSWORD: "RESET_PASSWORD",
    CONFIRM_RESET_PASSWORD_WITH_CODE: "CONFIRM_RESET_PASSWORD_WITH_CODE",
  },
  LAMBDA_URL: (() => {
    const { environmentConfig } = require('../config/config.js');
    return environmentConfig.LAMBDA_URL;
  })(),
  COMMON: {
    BASE_URL: (() => {
      const { environmentConfig } = require('../config/config.js');
      return process.env.REACT_APP_BASE_URL || environmentConfig.BASE_URL;
    })()
  },
  STRIPE: {
    PK: process.env.REACT_APP_STRIPE_PK,
    PRICE_ID: process.env.REACT_APP_PRICE_ID
  },
  TAX_API: {
    KEY: process.env.REACT_APP_NINJA_API_KEY,
    BASE_URL: (() => {
      const { environmentConfig } = require('../config/config.js');
      return environmentConfig.EXTERNAL_APIS?.TAX_API || 'https://api.api-ninjas.com/v1';
    })()
  }
};
